import React from 'react';

import * as Styled from './ButtonCta.styles';

export interface ButtonCtaProps {
  onAction: () => void;
  label: string;
  fullIcon: boolean;
  solid?: boolean;
  onDisabled: boolean;
}

const ButtonCta: React.FC<ButtonCtaProps> = ({
  onAction,
  label,
  onDisabled,
  fullIcon,
  solid,
}) => {
  return (
    <Styled.ButtonWrapper onClick={onAction}>
      {fullIcon ? 
        <Styled.Icon disabled={onDisabled} />
        :
        (solid ? <Styled.Button disabled={onDisabled}>{label}</Styled.Button> 
        : <Styled.ButtonSolid disabled={onDisabled}>{label}</Styled.ButtonSolid>)
      }
    </Styled.ButtonWrapper>
  );
};

export default ButtonCta;
